/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import _ from 'lodash'
import { Form } from 'semantic-ui-react'
import Select from 'react-select'

export default class RestaurantsField extends React.PureComponent {
  generateDropDownRestaurants = () => {
    const { restaurants } = this.props
    const selectOptions = []

    _.forEach(restaurants, restaurant => {
      if (restaurant.status === 'publish') {
        selectOptions.push({
          label: restaurant.name,
          value: restaurant.key,
        })
      }
    })

    return selectOptions
  }

  render() {
    const { value, onChange } = this.props
    const options = this.generateDropDownRestaurants()

    return (
      <Form.Field required>
        <label>Restaurants</label>
        <Select
          required
          menuPlacement="bottom"
          isSearchable
          placeholder="Please choose restaurant"
          onChange={res => onChange(res.value)}
          defaultValue={_.find(options, item => item.value === value)}
          options={options}
        />
      </Form.Field>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/deliveryFeeOffer/fields/restaurantsField.js